import styled from 'styled-components';
import { stableScrollGutter } from '../../assets/styles/components/scrollGutter';

export const DetailScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  ${stableScrollGutter}
  .detail-scroll-content {
    flex-grow: 1;
    padding-bottom: var(--spacing-gutter);
  }
`;
